export default {
  title: 'Bubble Game Universe',
  tokenName: 'Bubble Game Universe',
  description: '泡泡遊戲是 GGMOMOMO品牌打造的遊戲世界。\n\n從一枚 Meme Coin - BBT 開始，Bubble Game 逐漸發展成結合故事探索、角色成長、挖礦、戰鬥、裝備收集與遺物熔合等玩法的完整遊戲生態。\n\n玩家將跟隨主角波皮走進充滿蒸汽、鐵鏽與秘密的世界，在冒險中探索未知、發掘礦石與遺物、培養自己的角色，並透過不同遊戲活動獲得 BBG。\n\n而 Bubble Game 的故事，才剛剛開始。',
  enterGame: '進入遊戲',
  openInfo: '開啟 Bubble Game Universe 說明',
  close: '關閉 Bubble Game Universe 說明',
  deepLinkNotConfigured: 'Bubble Game 連結尚未設定。',
} as const;
